<input type="checkbox" [id]="id" #inputBox data-lpignore="true" autocomplete="off"
    [ngStyle]="useViewPortDimensions === false ? {'width.px': width, 'height.px': height} : {'width': width + 'vmin', 'height': height + 'vmin'}"
    [(ngModel)]="isChecked" (click)="clicked.emit($event)"
    (change)="changed.emit(inputBox?.checked)" [disabled]="disable" />